import React from "react";
import { RAW_PUT } from "Common/api";
import { refreshContextToken } from "Common/api/functions";
import Checker from "./checker";

require("./style.css");

export default class PasswordManager extends Checker {
  constructor(props, context) {
    super(props, context);
    this.updatePassword = this.updatePassword.bind(this);
    this.submitOnEnter = this.submitOnEnter.bind(this);
  }

  async updatePassword() {
    const errors = {};
    let success = false;
    const nextVal = this.next.value;

    this.checkPolicy(nextVal, errors);

    if (!this.current.value)
      this.addError(errors, "error_current", this.l("enterPassWord"));

    if (!this.next.value)
      this.addError(errors, "error_next", this.l("enterPassWord"));

    if (!this.repeat.value)
      this.addError(errors, "error_repeat", this.l("lblVerifyPassword"));

    if (nextVal !== this.repeat.value)
      this.addError(errors, "error_repeat", this.l("passwordsDontMatch"));
    success = false;
    if (Object.keys(errors).length <= 0) {
      success = await RAW_PUT(
        "v1/setpassword",
        {},
        { old: this.current.value, new: nextVal },
      ).then(async (res) => {
        if (res.status === 200) {
          await refreshContextToken();

          return true;
        }
        const errorText = await res.json();
        this.addError(errors, "error_current", this.l(errorText.message));

        return false;
      });
    }

    this.setState({ errors, didSave: success });
  }

  submitOnEnter(e) {
    if (e.keyCode === 13) {
      this.updatePassword();
      e.preventDefault();
    }
  }

  doRender() {
    const { ready, errors, didSave } = this.state || {};

    if (!ready) return <div />;

    const {
      error_current: errorCurrent = [],
      error_next: errorNext = [],
      error_repeat: errorRepeat = [],
    } = errors || {};

    return (
      <div>
        {didSave && (
          <div id="cPlhMain_DivInfoPwd" className="info-message success-banner">
            {this.l("infosaved")}
          </div>
        )}

        <div className="flex align-c relative flex-wrap">
          <div className="passwordmanager-column">
            <label htmlFor="passwordmanager-current">
              {this.l("hdrPresentPwd")}:
            </label>
          </div>
          <br />
          <input
            id="passwordmanager-current"
            type="password"
            ref={(input) => {
              this.current = input;
            }}
            onKeyDown={this.submitOnEnter}
            maxLength="255"
            className={errorCurrent.length > 0 ? "error" : ""}
          />
          <span className="passwordmanager-error animated fadeInDown">
            {errorCurrent.map((e, i) => (
              <span key={i}>
                {e}
                <br />
              </span>
            ))}
          </span>
        </div>

        <br />

        <div className="flex align-c relative flex-wrap">
          <div className="passwordmanager-column">
            <label htmlFor="passwordmanager-next">{this.l("hdrnewpwd")}:</label>
          </div>
          <br />
          <input
            id="passwordmanager-next"
            type="password"
            ref={(input) => {
              this.next = input;
            }}
            onKeyDown={this.submitOnEnter}
            maxLength="255"
            className={errorNext.length > 0 ? "error" : ""}
          />
          <span className="passwordmanager-error animated fadeInDown">
            {errorNext.map((e, i) => (
              <span key={i}>
                {e}
                <br />
              </span>
            ))}
          </span>
        </div>

        <br />

        <div className="flex align-c relative flex-wrap">
          <div className="passwordmanager-column">
            <label htmlFor="passwordmanager-repeat">
              {this.l("lblVerifyPassword")}:
            </label>
          </div>
          <br />
          <input
            id="passwordmanager-repeat"
            type="password"
            ref={(input) => {
              this.repeat = input;
            }}
            onKeyDown={this.submitOnEnter}
            maxLength="255"
            className={errorRepeat.length > 0 ? "error" : ""}
          />
          <span className="passwordmanager-error animated fadeInDown">
            {errorRepeat.map((e, i) => (
              <span key={i}>
                {e}
                <br />
              </span>
            ))}
          </span>
        </div>
        <br />
        <div>
          <button
            type="button"
            className="button-cta"
            onClick={this.updatePassword}
          >
            {this.l("save")}
          </button>
        </div>
      </div>
    );
  }
}
